<template>
  <div class="course-container">
    <div v-if="!error && courseId">

      <!--Begin Top Nav Bar-->
      <div class="course-nav-bar">
        <b-container>
          <!--Calendar-->
          <router-link :to="{name:'Calendar', params: { courseId: courseId }}">Calendar</router-link>

          <!--Appointment-->
          <router-link :to="{name:'Appointment', params: { courseId: courseId }}" v-if="courses[courseId]['appointment']">
            Book Tutor Appointment
          </router-link>

          <!--Piazza-->
          <a :href="courses[courseId]['piazza']" target="_blank" v-if="courses[courseId]['piazza']">
            Piazza
          </a>
        </b-container>
        <!--End Top Nav Bar-->
      </div>

      <!--Begin Content Container-->
      <b-container>
        <router-view class="course-inner-container"></router-view>
      </b-container>
      <!--End Content Container-->
    </div>

    <p v-else>{{ error }}</p>

  </div>
</template>

<script>
import Calendar from 'components/global/submodule/Calendar'

import courses from 'components/courses/settings'

export default {
  name: 'Course',
  components: { Calendar },
  data () {
    return {
      courses: courses,
      courseId: '',
      error: null
    }
  },
  watch: {
    '$route.params': {
      immediate: true,
      deep: true,
      handler: function (params) {
        if (params['courseId'] && params['courseId'] in courses) {
          this.courseId = params['courseId']
          this.error = null
          document.title = [courses[this.courseId]['class'], 'Self-Paced Center'].join(' | ')
        } else {
          this.courseId = null
          this.error = 'Course Not Found'
          document.title = this.error
        }
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import "~assets/colors.styl"

  .course-container {
    padding-top: 0
    padding-bottom: 0

    .course-nav-bar {
      background-color $grey
      text-align center

      a {
        margin 0 5px
        padding 10px 15px
        display inline-block
        color $blue-chambray
        text-decoration none
        &:hover, &:active {
          color $blue-dark
        }
        &.router-link-active {
          font-weight 700
        }
      }
    }

    .course-inner-container {
      padding-top 40px
      padding-bottom 40px
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/global/Course.vue